import { type TripRead } from 'src/common/external/bambi-api/tripsApi.generated';

export function shouldSeparateReasonValueAndLabel(trip?: TripRead) {
  /**
   * Return true when you want to pass the reason value, and label separately.
   * Useful for brokers that supply an int code and string reason.
   */
  if (!trip?.id) {
    return false;
  }

  return trip.intermediary === 'modivcare';
}
